import React, { useContext, useEffect, useRef } from "react";
import "../../../../styles/workspace_styles/CustomerUserStyles/Dashboards/Dashboard.css";
import DashboardState from "./DashboardState.jsx";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import { DashboardContext } from "./DashboardProvider.jsx";
import NavigationBar from "../../../navigation_components/NavigationBar.jsx";
import CustomerUserSideBar from "../../../sidebar_components/CustomerUserSideBar.jsx";
import { AppContext } from "../../../AppProvider.jsx";
import { useParams } from "react-router-dom";
import {WidgetRenderDelays} from "../../../Widgets/WidgetRenderDelays.js";
import VerticalCylinderTankWidget from "../../../Widgets/LiquidLevel/Widgets/VerticalCylinderTankWidget.jsx";
import LineChartWidget from "../../../Widgets/Charts/Widgets/LineChartWidget.jsx";
import BarChartWidget from "../../../Widgets/Charts/Widgets/BarChartWidget.jsx";
const Dashboard = () =>{
    const {
        dashboard,
        setDashboard,
        setShowManageDashboardStates,
        activeDashboardState,setActiveDashboardState,
        maximizedWidget,setMaximizedWidget,
        refreshDashboardState
    } = useContext(DashboardContext);
    const {user,customerIotProfile} = useContext(AppContext);
    const { customerUserId, dashboardId } = useParams();
    const initialRender = useRef(true);
    const fetchAndSetDashboard = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/customers/users/admin/${customerUserId}/dashboards/${dashboardId}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setDashboard(responseData);
            }
            else throw new Error(`Error code: ${response.status}`);
        }
        catch(error){
            console.error(`An error occurred when fetching dashboard with id: ${dashboardId} from the server`,error);
        }
    };
    const extractDashboardTimeWindowHeader = () =>{
        if(!dashboard?.timeWindow || dashboard.timeWindow?.history?.historyType === undefined) return '';
        if(dashboard.timeWindow.selectedTab === 0){
            if(dashboard.timeWindow.history.historyType === 0){
                switch(dashboard.timeWindow.history?.timeWindowMs){
                    case 1000:
                        return 'Realtime - Last 1 second';
                    case 5000:
                        return 'Realtime - Last 5 seconds';
                    case 10000:
                        return 'Realtime - Last 10 seconds';
                    case 15000:
                        return 'Realtime - Last 15 seconds';
                    case 30000:
                        return 'Realtime - Last 30 seconds';
                    case 60000:
                        return 'Realtime - Last 1 minute';
                    case 120000:
                        return 'Realtime - Last 2 minutes';
                    case 300000:
                        return 'Realtime - Last 5 minutes';
                    case 600000:
                        return 'Realtime - Last 10 minutes';
                    case 900000:
                        return 'Realtime - Last 15 minutes';
                    case 1800000:
                        return 'Realtime - Last 30 minutes';
                    case 3600000:
                        return 'Realtime - Last 1 hour';
                    case 7200000:
                        return 'Realtime - Last 2 hours';
                    case 18000000:
                        return 'Realtime - Last 5 hours';
                    case 36000000:
                        return 'Realtime - Last 10 hours';
                    case 43200000:
                        return 'Realtime - Last 12 hours';
                    case 86400000:
                        return 'Realtime - Last 1 day';
                    case 604800000:
                        return 'Realtime - Last 7 days';
                    case 2592000000:
                        return 'Realtime - Last 30 days';
                    default:
                        return '';
                }
            }
        }
        else if(dashboard.timeWindow.selectedTab === 1){
            if(dashboard.timeWindow.history.historyType === 0){
                switch(dashboard.timeWindow.history?.timeWindowMs){
                    case 60000:
                        return 'History - last second';
                    case 300000:
                        return 'History -last 5 seconds';
                    default:
                        return '';
                }
            }
        }
        return '';
    };
    useEffect(() =>{
        document.title = 'Blink IOT | Dashboard';
        return () =>{
            setDashboard(null);
            setMaximizedWidget(null);
            setActiveDashboardState(null);
        };
    },[]);
    useEffect(() =>{
        if(!dashboard) return;
        if(!activeDashboardState){
            dashboard?.dashboardStates?.forEach((dashboardState) =>{
                if(dashboardState.rootState) setActiveDashboardState(dashboardState);
            });
        }
        else if(refreshDashboardState.current){
            const matched = dashboard?.dashboardStates?.find(ds => ds?.id === activeDashboardState?.id);
            if (matched) setActiveDashboardState(matched);
            const totalExpectedDelay = matched?.widgets?.reduce((sum,widget) =>{
                return sum + (WidgetRenderDelays[widget?.type]?? 1);
            },0);
            requestAnimationFrame(() => {
                setTimeout(() => {
                    refreshDashboardState.current = false;
                }, totalExpectedDelay);
            });
        }
    },[dashboard]);
    useEffect(() =>{
        fetchAndSetDashboard();
    },[customerUserId,dashboardId]);
    return(
        <div>
            {maximizedWidget? (
                <div>
                    {(() =>{
                        switch(maximizedWidget?.widget?.type)
                        {
                            case 'vertical_cylinder_tank':
                                return (
                                    <div key={maximizedWidget?.widget?.id}>
                                        <VerticalCylinderTankWidget
                                            key={maximizedWidget?.widget?.id}
                                            DashboardContext={DashboardContext}
                                            widget={maximizedWidget?.widget}
                                            setWidgets={maximizedWidget?.setWidgets}
                                            bounds={maximizedWidget?.bounds}
                                            setDraggingOrResizing={maximizedWidget?.setDraggingOrResizing}
                                            MOBILE_COMPUTER_SCREEN_BOUNDARY={maximizedWidget?.MOBILE_COMPUTER_SCREEN_BOUNDARY}
                                        />
                                    </div>
                                );
                            case 'line_chart':
                                return (
                                    <div key={maximizedWidget?.widget?.id}>
                                        <LineChartWidget
                                            key={maximizedWidget?.widget.id}
                                            DashboardContext={DashboardContext}
                                            widget={maximizedWidget?.widget}
                                            setWidgets={maximizedWidget?.setWidgets}
                                            bounds={maximizedWidget?.bounds}
                                            setDraggingOrResizing={maximizedWidget?.setDraggingOrResizing}
                                            MOBILE_COMPUTER_SCREEN_BOUNDARY={maximizedWidget?.MOBILE_COMPUTER_SCREEN_BOUNDARY}
                                        />
                                    </div>
                                );
                            case 'bar_chart':
                                return (
                                    <div key={maximizedWidget?.widget?.id}>
                                        <BarChartWidget
                                            key={maximizedWidget?.widget.id}
                                            DashboardContext={DashboardContext}
                                            widget={maximizedWidget?.widget}
                                            setWidgets={maximizedWidget?.setWidgets}
                                            bounds={maximizedWidget?.bounds}
                                            setDraggingOrResizing={maximizedWidget?.setDraggingOrResizing}
                                            MOBILE_COMPUTER_SCREEN_BOUNDARY={maximizedWidget?.MOBILE_COMPUTER_SCREEN_BOUNDARY}
                                        />
                                    </div>
                                );
                        }
                    })()
                    }
                </div>
            ):(
                <div className="customer-user-dashboard-page">
                    <NavigationBar/>
                    <div className={`customer-user-dashboard-page-layout ${customerIotProfile?.defaultDashboardAlwaysFullScreen? 'full-screen':''}`}>
                        <div style={{display: customerIotProfile?.defaultDashboardAlwaysFullScreen? 'none':'block'}}>
                            <CustomerUserSideBar/>
                        </div>
                        <div className="customer-user-dashboard-parent-container">
                            <div className="customer-user-dashboard-container">
                                <div className="customer-user-dashboard-content-container">
                                    <div className={`customer-user-dashboard-controls-parent-container`}>
                                        <div className="customer-user-dashboard-header-controls-container left">
                                            <p style={{cursor:'default'}}>{dashboard?.title}</p>
                                            <button
                                                style={{display:`none`}}
                                                onClick={() => setShowManageDashboardStates(true)}>
                                                <span style={{fontSize:"20px",fontWeight:"bold",marginRight:"10px"}}>&#8801;</span>
                                                <span>States</span>
                                            </button>
                                        </div>
                                        <div className="customer-user-dashboard-header-controls-container right">
                                            <button title="Edit time window">
                                                <img src={`${process.env.PUBLIC_URL}/images/clock-icon.png`}/>
                                                <span style={{marginLeft:'5px'}}>{extractDashboardTimeWindowHeader()}</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className={`customer-user-dashboard-state-container`}>
                                        <DashboardState/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
export default Dashboard;